import { Button, Col, Label, Modal, ModalBody, ModalFooter, ModalHeader, Row, Spinner } from "reactstrap";
import { H3 } from "../../../../AbstractElements";
import TextField from "../../../common/TextField";
import { useEffect, useState } from "react";
import Dropdown from "../../../common/DropDown";
import { useGetRequestQuery } from "../../../../Hooks/useGetRequestQuery";
import { getAllAreas, GetAllproperties,GetAllpropertiesKenket, getAllStates } from "../../../../Services/MMPClientServices/PropertySearchService";
import property from '../../MMPClient/PropertySearch/property.json';
import DropdownWithValueName from "../../../common/DropdownWithValueName";
import { Link } from "react-router-dom";
import { softDeletePropertyService } from "../../../../Services/CRMAdminServices/CRMPropertyService";
import { useMutationRequestQuery } from "../../../../Hooks/useMutationRequestQuery";
import { toast } from "react-toastify";
import BootstrapTable from "react-bootstrap-table-next";
import { useSafeNavigate } from "../../../../Hooks/useSafeNavigate";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { CompanyProfile, ContactUsSection, EstateAndSubdivisionImages, Floorplan, Inclusions, RentAppraisal, PackageDownload, PropertyFlyer, StateReport } from "./PropertyFlyer";
import { getAllBuildersService } from "../../../../Services/CRMAdminServices/CRMBuildersService";

import { RootState } from '../../../../ReduxToolkit/Store';
import { useSelector } from 'react-redux';
// Utility function to convert image URL to base64
const getBase64FromUrl = async (url: string): Promise<string> => {
    try {
        const response = await fetch(url);
        const blob = await response.blob();
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onloadend = () => resolve(reader.result as string);
            reader.onerror = reject;
            reader.readAsDataURL(blob);
        });
    } catch (error) {
        console.error('Error converting image to base64:', error);
        return '';
    }
};

export default function CRMPropertySearchcopy() {
    const [propertiesData, setPropertiesData] = useState<any>([]);
    const [currentPage, setCurrentPage] = useState(1);
    // const [pageSize] = useState(20);   // fix 10 at a time
    const [pageSize] = useState(25);

    const [hasMore, setHasMore] = useState(true);
    // const [propertiesData, setPropertiesData] = useState<any>([]);
    // const [currentPage, setCurrentPage] = useState(1);
    // const [pageSize, setPageSize] = useState(10);
    const [searchTrigger, setSearchTrigger] = useState(0);
    const [statesData, setStatesData] = useState<any>([]);
    const [suburb, setSuburb] = useState<any[]>([]);
    const [areasData, setAreasData] = useState<any>([]);
    const [deleteModal, setDeleteModal] = useState(false);
    const [selectedLeadsId, setCheckedPropertyIds] = useState<any>([])
    const [loading, setLoading] = useState(false);
    const [selectedFlyer, setSelectedFlyer] = useState<any>({})
    const [selectedPackage, setSelectedPackage] = useState<any>({})
    // const BASE_URL = `${process.env.REACT_APP_API_BASE_URL}/PropertyImages/`;
    // const [yieldSortOrder, setYieldSortOrder] = useState(""); // "yes", "no", or ""
    const [builders, setBuilders] = useState<any[]>([]);
    const [selectedPropertyId, setSelectedPropertyId] = useState<number | null>(null);
    const [selectedFile, setSelectedFile] = useState<File | null>(null);
    // const [isModalOpen, setIsModalOpen] = useState(false);
    // Add new state for property details modal
    const [propertyDetailsModal, setPropertyDetailsModal] = useState(false);
    const [selectedPropertyDetails, setSelectedPropertyDetails] = useState<any>(null);

    const [formData, setFormData] = useState({
        propertyId: '',
        state: '',
        yield: '',
        minimumBed: '',
        maxPrice: '',
        area: '',
        titled: '',
        contractType: '',
        propType: '',
        suburb: '',
        landSize: '',
        houseSize: '',
        supplier: '',
        propertyKenket: '2',

    });

    const handleValueChange = (name: string, value: string | number) => {
        setFormData({ ...formData, [name]: value });
    };
    const { RoleName, RoleID, nameidentifier: userID, FirstName } = useSelector((state: RootState) => state.adminAuth);
    const [isModalOpen, setIsModalOpen] = useState(false);
    // useEffect(() => {
    //   console.log("RoleName:", RoleName);
    //   console.log("RoleId:", RoleID);
    //   console.log("UserID:", userID);
    //   console.log("FirstName:", FirstName);
    // }, [RoleName, userID, FirstName]);

    const handleUpload = async () => {
        if (!selectedFile || !selectedPropertyId) {
            alert("Please select a PDF file first");
            return;
        }

        try {
            const formData = new FormData();
            formData.append("PropertyId", String(selectedPropertyId)); // 👈 ID
            formData.append("BrochureFile", selectedFile);             // 👈 file
            const baseUrl = process.env.REACT_APP_API_BASE_URL;
               const token = localStorage.getItem('token');
            const response = await fetch(`${baseUrl}/api/Property/upload-brochure`, {
                method: "POST",
                 headers: {
                'Authorization': `Bearer ${token}`
            },
                body: formData,
            });

            if (response.ok) {
                toast.success("Brochure uploaded successfully!");
                setIsModalOpen(false);
                setSelectedFile(null);
                setSelectedPropertyId(null);
                refetch(); // 👈 refresh table
            } else {
                toast.error("Failed to upload brochure.");
            }
        } catch (error) {
            console.error("Upload error:", error);
            toast.error("Error uploading file.");
        }
    };


    const closeModal = () => {
        setIsModalOpen(false);
    };




    const navigate = useSafeNavigate();

    const selectedArea: any = areasData.filter((area: any) => area.value == formData.area);
    const selectedSuburb: any = suburb.filter((area: any) => area.value == formData.suburb);
    const selectedSupplier: any = builders.filter((builder: any) => builder.value == formData.supplier);
    // Dynamic params object
    const params = {
        // PageNumber: 0,
        // PageSize: 0,
        PageNumber: currentPage,
        PageSize: pageSize,
        Area: selectedArea[0]?.value,
        // clientId : userData?.nameidentifier,
        PropertyType: formData.propType,
        Bedrooms: formData.minimumBed,
        Price: formData.maxPrice,
        MaximumPrice: formData.maxPrice,
        Suburb: selectedSuburb[0]?.value,
        SearchedLandSQM: formData.landSize,
        ContractType: formData.contractType,
        Title: formData.titled,
        PropertyId: formData.propertyId,
        Supplier: selectedSupplier[0]?.value || "",
        stateid: formData.state,
        propertyKenket: formData.propertyKenket ?? "2",
        PropertyName: ""
    };

    const {
        data: allPropertiesData,
        isLoading: allPropertiesLoading,
        isError: allPropertiesIsError,
        refetch
    } = useGetRequestQuery(
        ["GetAllpropertiesKenket", currentPage, pageSize, searchTrigger],
        () => GetAllpropertiesKenket(params as any),
        {
            enabled: true,
        }
    );


    useEffect(() => {
        if (allPropertiesData?.data && !allPropertiesIsError && !allPropertiesLoading) {
            setPropertiesData(allPropertiesData.data); // 👈 overwrite instead of append

            setHasMore(allPropertiesData.data.length === pageSize); // if less than 25, no more pages
        }

        if (allPropertiesData?.data?.length === 0 && currentPage === 1) {
            setPropertiesData([]);
            setHasMore(false);
        }
    }, [allPropertiesData, allPropertiesIsError, allPropertiesLoading, currentPage]);

    // useEffect(() => {
    //     if (allPropertiesData?.data && !allPropertiesIsError && !allPropertiesLoading) {
    //         if (currentPage === 1) {
    //             // 👇 fresh search → overwrite
    //             setPropertiesData(allPropertiesData.data);
    //         } else {
    //             // 👇 infinite scroll → append
    //             setPropertiesData((prev: any) => {
    //                 const existingIds = new Set(prev.map((p: any) => p.propertyId));
    //                 const uniqueNew = allPropertiesData.data.filter((p: any) => !existingIds.has(p.propertyId));
    //                 return [...prev, ...uniqueNew];
    //             });
    //         }

    //         if (allPropertiesData.data.length < pageSize) {
    //             setHasMore(false);
    //         }
    //     }

    //     if (allPropertiesData?.data?.length === 0 && currentPage === 1) {
    //         setPropertiesData([]); // no results
    //         setHasMore(false);
    //     }
    // }, [allPropertiesData, allPropertiesIsError, allPropertiesLoading, currentPage]);
    // useEffect(() => {
    //     if (allPropertiesData?.data && !allPropertiesIsError && !allPropertiesLoading) {
    //         setPropertiesData(allPropertiesData?.data);
    //     }
    // }, [allPropertiesData, allPropertiesIsError, allPropertiesLoading]);
    // useEffect(() => {
    //     const handleScroll = () => {
    //         if (
    //             window.innerHeight + document.documentElement.scrollTop + 100 >=
    //             document.documentElement.offsetHeight
    //         ) {
    //             if (hasMore && !allPropertiesLoading) {
    //                 setCurrentPage((prev) => prev + 1);
    //             }
    //         }
    //     };

    //     window.addEventListener("scroll", handleScroll);
    //     return () => window.removeEventListener("scroll", handleScroll);
    // }, [hasMore, allPropertiesLoading]);

    const { data: buildersData, isLoading: buildersLoading, isError: buildersIsError } = useGetRequestQuery<any>(
        ['getAllBuilders'],
        getAllBuildersService,
        { enabled: true }
    );
    useEffect(() => {
        if (buildersData?.data && !buildersIsError && !buildersLoading) {
            const transformedData = buildersData.data.map((builder: any) => ({
                value: builder.supplierId,
                label: builder.supplier
            }));
            setBuilders(transformedData);
        }
    }, [buildersData, buildersIsError, buildersLoading]);

    const {
        data: allStatesData,
        isLoading: allStatesLoading,
        isError: allStatesIsError,
    } = useGetRequestQuery(
        ["getAllStates"],
        getAllStates,
        {
            enabled: true,
        }
    );
    useEffect(() => {
        if (allStatesData?.data && !allStatesIsError && !allStatesLoading) {
            const transformedData = allStatesData.data.map((state: any) => ({
                value: state.id,
                label: state.name
            }));
            setStatesData(transformedData);
        }
    }, [allStatesData, allStatesIsError, allStatesLoading]);




    const {
        data: allAreasData,
        isLoading: allAreasLoading,
        isError: allAreasIsError,
    } = useGetRequestQuery(
        ["getAllAreas", formData.state],
        () => getAllAreas({
            searchId: formData.state,
            searchType: "area"
        }),
        {
            enabled: !!formData.state,
        }
    );

    useEffect(() => {
        // if (allAreasData?.data && !allAreasIsError && !allAreasLoading) {
        //     const transformedData = allAreasData?.data?.map((area: any) => ({
        //         value: area.id,
        //         label: area.name
        //     }));

        //     setAreasData(transformedData);
        // }


        if (allAreasData?.data && !allAreasIsError && !allAreasLoading) {
            const transformedData = allAreasData.data
                .map((area: any) => ({
                    value: area.id,
                    label: area.name
                }))
                .sort((a: any, b: any) => a.label.localeCompare(b.label)); // <-- Sort alphabetically

            setAreasData(transformedData);
        }
    }, [allAreasData, allAreasIsError, allAreasLoading]);


    const {
        data: allSuburbsData,
        isLoading: allSuburbsLoading,
        isError: allSuburbsIsError,
    } = useGetRequestQuery(
        ["getAllSuburbs", formData.area],
        () => getAllAreas({
            searchId: formData.area,
            searchType: "suburb"
        }),
        {
            enabled: !!formData.area,
        }
    );

    useEffect(() => {
        if (allSuburbsData?.data && !allSuburbsIsError && !allSuburbsLoading) {
            const transformedSuburbsData = allSuburbsData.data
                .map((suburb: any) => ({
                    value: suburb.id,
                    label: suburb.name,
                }))
                .sort((a: any, b: any) => a.label.localeCompare(b.label)); // <-- Sort alphabetically

            setSuburb(transformedSuburbsData);
        }
    }, [allSuburbsData, allSuburbsIsError, allSuburbsLoading]);

    const handleSearch = () => {
        setPropertiesData([]);
        setCurrentPage(1);       // 👈 page reset
        setHasMore(true);        // 👈 allow more data
        setSearchTrigger((prev) => prev + 1);

        window.scrollTo(0, 0);
    };

    const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (e.target.files && e.target.files[0]) {
            const file = e.target.files[0];
            if (file.type === "application/pdf") {
                setSelectedFile(file);
            } else {
                alert("Please upload a PDF file only.");
            }
        }
    };







    const exportToPDF = () => {
        const pdf = new jsPDF({ orientation: "landscape" });
        const logo = new Image();
        logo.src = "/assets/images/fintrack_logo.png";

        logo.onload = () => {
            const margin = 10;
            const logoWidth = 60;
            const logoHeight = 15;

            const logoX = margin;
            const logoY = margin;

            pdf.addImage(logo, "PNG", logoX, logoY, logoWidth, logoHeight);

            const options: Intl.DateTimeFormatOptions = { day: "numeric", month: "long", year: "numeric" };
            const currentDate = new Date().toLocaleDateString("en-GB", options);

            pdf.setFontSize(11);
            pdf.setTextColor(0, 0, 0);

            const dateText = `Date: ${currentDate}`;
            const dateX = pdf.internal.pageSize.width - margin - pdf.getTextWidth(dateText);
            const dateY = logoY + (logoHeight / 2) + 4;
            pdf.text(dateText, dateX, dateY);

            const lineY = logoY + logoHeight + 10;
            pdf.setDrawColor(0, 0, 255);
            pdf.line(margin, lineY, pdf.internal.pageSize.width - margin, lineY);

            const mapStateIdToLabel = (stateId: any) => {
                const state = statesData.find((s: any) => s.value === stateId);
                return state ? state.label : "N/A";
            };


            const sortedData = [...propertiesData].sort((a, b) => {
                if (formData.yield === "Yes") {
                    return (b.rentYield || 0) - (a.rentYield || 0); // Highest yield first
                } else if (formData.yield === "No") {
                    return (a.rentYield || 0) - (b.rentYield || 0); // Lowest yield first
                } else {
                    const priceA = Number(String(a.price1Bedroom).replace(/,/g, ""));
                    const priceB = Number(String(b.price1Bedroom).replace(/,/g, ""));
                    return priceA - priceB;
                }
            });

            const excelData = sortedData.map((row: any) => [
                row.propertyId,
                row.propertyType,
                row.lotNumber,
                row.estate,
                row.propertyAddress,
                row.suburb,
                row.stateName,
                row.areaName,
                row.price1Bedroom,
                row.rentYield ? `${row.rentYield}%` : '',
                row.houseSize ? `${row.houseSize}` : '',
                row.landSize ? `${row.landSize}` : '',
                row.bedrooms,
                row.titled
            ]);







            const headers = [
                ["ID", "PropertyType", "Lot #", "Estate", "Address", "Suburb", "State", "Area", "Price", "Yield", "House", "Land", "Beds", "Titled"]
            ];

            autoTable(pdf, {
                head: headers,
                body: excelData,
                startY: lineY + 5,
                margin: { left: margin, right: margin },
                styles: { cellPadding: 2, lineWidth: 0, fontSize: 8 }, // smaller text
                // headStyles: { fillColor: [0, 0, 255], textColor: 255 },
                headStyles: { fillColor: [0, 0, 255], textColor: 255, fontSize: 9 }, // optional smaller header font

            });

            pdf.save("properties_data.pdf");
        };

        logo.onerror = () => {
            console.error("Error loading the logo image.");
        };
    };

    const { mutate: softDeleteProperty, isPending: isSoftDeletePending } = useMutationRequestQuery(
        "softDeleteProperty",
        softDeletePropertyService,
        {
            onSuccess: () => {
                toast.success("Properties deleted successfully.");
                refetch();
                setDeleteModal(false);
                setCheckedPropertyIds([]);
            },
            onError: () => {
                toast.error("Failed to delete properties.");
                setDeleteModal(false);
            },
        }
    );

    const confirmDeleteProperty = () => {
        setDeleteModal(true);
    };

    const handleDeletePropertyClick = () => {
        softDeleteProperty(selectedLeadsId);
    };


    const selectRow = {
        mode: "checkbox",
        hideSelectAll: true,
        clickToSelect: false,
        selectColumnPosition: 'right',
        selectColumnStyle: { marginRight: "10px" },
        nonSelectable: propertiesData
            .filter((row: any) => row.propertyKenket === 1)
            .map((row: any) => row.propertyId), // 👈 Disable selection for these rows
        onSelect: (row: any, isSelect: boolean) => {
            setCheckedPropertyIds((prevSelected: any) =>
                isSelect
                    ? [...prevSelected, row.propertyId]
                    : prevSelected.filter((id: any) => id !== row.propertyId)
            );
        },
        onSelectAll: (isSelect: boolean, rows: any[]) => {
            setCheckedPropertyIds(isSelect ? rows.map(row => row.propertyId) : []);
        }
    };



    useEffect(() => {
        if (selectedFlyer && Object.keys(selectedFlyer).length > 0) {
            generatePDF();
        }
    }, [selectedFlyer]);

    useEffect(() => {
        if (selectedPackage && Object.keys(selectedPackage).length > 0) {
            generatePackagePDF();
        }
    }, [selectedPackage]);


    const generatePDF = async () => {
        if (!selectedFlyer) return;

        const htmlContent = await PropertyFlyer(selectedFlyer);

        // Create an off-screen container
        const hiddenElement = document.createElement("div");
        hiddenElement.style.width = "800px";
        hiddenElement.style.padding = "20px";
        hiddenElement.style.backgroundColor = "white";
        hiddenElement.style.fontFamily = "Arial, sans-serif";
        hiddenElement.style.position = "absolute";
        hiddenElement.style.left = "-9999px";
        hiddenElement.innerHTML = htmlContent;

        document.body.appendChild(hiddenElement);

        const canvas = await html2canvas(hiddenElement, {
            scale: 2,
            useCORS: true,
            allowTaint: true,
            logging: true,
            imageTimeout: 15000
        });

        const imgData = canvas.toDataURL("image/png");
        const pdf = new jsPDF("p", "mm", "a4");
        const imgWidth = 210;
        const imgHeight = (canvas.height * imgWidth) / canvas.width;
        pdf.addImage(imgData, "PNG", 0, 0, imgWidth, imgHeight);
        // pdf.save(`property-details-${selectedFlyer.propertyId}.pdf`);
        pdf.save(`$${selectedFlyer.price1Bedroom} - ID ${selectedFlyer.propertyId} - ${selectedFlyer.lotNumber} - ${selectedFlyer.suburb} - ${selectedFlyer.stateName}.pdf`);
        document.body.removeChild(hiddenElement);
    };

    // const generatePDF = async () => {
    //     if (!selectedFlyer) return;

    //     const htmlContent = PropertyFlyer(selectedFlyer);

    //     const newWindow = window.open("", "_blank");
    //     if (!newWindow) {
    //         alert("Please enable pop-ups in your browser.");
    //         return;
    //     }

    //     newWindow.document.write(`
    //         <html>
    //             <head>
    //                 <title>Property Flyer</title>
    //                 <style>
    //                     body {
    //                         font-family: Arial, sans-serif;
    //                         padding: 20px;
    //                         background-color: white;
    //                         margin: 0;
    //                     }
    //                     img {
    //                         max-width: 100%;
    //                         height:350px;
    //                     }
    //                     /* Scale everything down to fit one page */
    //                     @media print {
    //                         body {
    //                             transform-origin: top center;
    //                             transform: scale(0.8); /* adjust scale to fit */
    //                             width: 100vw;
    //                             height: 100vh;
    //                             overflow: hidden;
    //                         }
    //                         /* Remove default margins to use full page */
    //                         @page {
    //                             margin: 0;
    //                         }
    //                     }
    //                 </style>
    //             </head>
    //             <body>
    //                 ${htmlContent}
    //             </body>
    //         </html>
    //     `);
    //     newWindow.document.close();

    //     newWindow.onload = () => {
    //         newWindow.focus();
    //         newWindow.print();
    //         // newWindow.close();
    //     };
    // };


    const generatePackagePDF = async () => {
        setLoading(true);
        const pdf = new jsPDF("p", "mm", "a4");
        const imgWidth = 210;

        const addHtmlToPdf = async (htmlContent: any, isFirstPage = false) => {
            const hiddenElement = document.createElement("div");
            hiddenElement.style.width = "800px";
            hiddenElement.style.padding = "20px";
            hiddenElement.style.backgroundColor = "white";
            hiddenElement.style.fontFamily = "Arial, sans-serif";
            hiddenElement.style.position = "absolute";
            hiddenElement.style.left = "-9999px";
            hiddenElement.style.overflow = "visible";
            hiddenElement.innerHTML = htmlContent;

            // Convert all images to base64 before rendering
            const images = Array.from(hiddenElement.getElementsByTagName('img'));
            for (let img of images) {
                if (img.src && !img.src.startsWith('data:')) {
                    try {
                        const base64 = await getBase64FromUrl(img.src);
                        img.src = base64;
                    } catch (error) {
                        console.error('Error converting image to base64:', error);
                        img.src = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=';
                    }
                }
            }

            document.body.appendChild(hiddenElement);

            const canvas = await html2canvas(hiddenElement, {
                scale: 2.0,
                useCORS: true,
                allowTaint: true,
                logging: false,
                imageTimeout: 15000,
                windowWidth: 800
            });

            const imgData = canvas.toDataURL("image/jpeg", 0.85);
            const imgHeight = (canvas.height * imgWidth) / canvas.width;

            if (!isFirstPage) pdf.addPage();
            pdf.addImage(imgData, "JPEG", 0, 0, imgWidth, imgHeight);

            document.body.removeChild(hiddenElement);
        };

        try {
            // Await all async components
            const [
                packageHtml,
                stateReportHtml,
                companyProfileHtml,
                floorplanHtml,
                estateImagesHtml,
                inclusionsHtml,
                RentAppraisalHtml,
                contactUsHtml,
            ] = await Promise.all([
                PackageDownload(selectedPackage),
                StateReport(),
                CompanyProfile(),
                Floorplan(selectedPackage),
                EstateAndSubdivisionImages(selectedPackage),
                Inclusions(selectedPackage),
                RentAppraisal(selectedPackage),
                ContactUsSection()
            ]);

            // Add each page to the PDF
            await addHtmlToPdf(packageHtml, true);
            // await addHtmlToPdf(stateReportHtml);
            await addHtmlToPdf(companyProfileHtml);
            await addHtmlToPdf(floorplanHtml);
            await addHtmlToPdf(estateImagesHtml);
            await addHtmlToPdf(inclusionsHtml);
            await addHtmlToPdf(RentAppraisalHtml);
            await addHtmlToPdf(contactUsHtml);

            // Convert PDF to Blob
            const pdfBlob = pdf.output("blob");
            const pdfUrl = URL.createObjectURL(pdfBlob);

            // Open in new tab with property ID and package name in filename
            // const fileName = `Property-${selectedPackage.propertyId}-Package.pdf`;
            const fileName = `$${selectedPackage.price1Bedroom} - ID ${selectedPackage.propertyId} - ${selectedPackage.lotNumber} - ${selectedPackage.suburb} - ${selectedPackage.stateName}.pdf`;
            const link = document.createElement('a');
            link.href = pdfUrl;
            link.download = fileName;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            URL.revokeObjectURL(pdfUrl);

            setLoading(false);
        } catch (error) {
            console.error('Error generating PDF:', error);
            setLoading(false);
            toast.error('Failed to generate PDF');
        }
    };
    useEffect(() => {
        if (loading) {
            toast.info("Generating PDF, please wait...", {
                autoClose: 2000,
                closeButton: true,
            });
        }
    }, [loading]);




    // const sortedPropertiesData = [...propertiesData].sort((a, b) => a.price1Bedroom - b.price1Bedroom);
    const sortedPropertiesData = [...propertiesData].sort((a, b) => {
        // const priceA = Number(String(a.price1Bedroom).replace(/,/g, ""));
        // const priceB = Number(String(b.price1Bedroom).replace(/,/g, ""));
        // return priceA - priceB;

        if (formData.yield == "Yes") {
            console.log("Highest yield first");
            // Highest yield first
            return (b.rentYield || 0) - (a.rentYield || 0);
        } else if (formData.yield == "No") {
            console.log("Lowest yield first");
            // Lowest yield first
            return (a.rentYield || 0) - (b.rentYield || 0);
        } else {
            // Default: sort by price
            const priceA = Number(String(a.price1Bedroom).replace(/,/g, ""));
            const priceB = Number(String(b.price1Bedroom).replace(/,/g, ""));
            return priceA - priceB;
        }
    });
    const propertyColumns = [
        { dataField: "propertyId", text: "ID", headerStyle: { width: "2rem", color: "#0000ff" } },
        { dataField: "stateName", text: "State", headerStyle: { color: "#0000ff" } },
        //  { dataField: "propertyState", text: "State", headerStyle: { color: "#0000ff" } },
        
        { dataField: "propertyType", text: "Property Type", headerStyle: { width: "12rem", color: "#0000ff" } },
        { dataField: "lotNumber", text: "Lot", headerStyle: { color: "#0000ff" } },

        { dataField: "propertyAddress", text: "Address", headerStyle: { width: "12rem", color: "#0000ff" } },
        { dataField: "estate", text: "Estate", headerStyle: { color: "#0000ff" } },
        { dataField: "suburb", text: "Suburb", headerStyle: { color: "#0000ff" } },
        // { dataField: "suburbname", text: "Suburb", headerStyle: { color: "#0000ff" } },
        {
            dataField: "price1Bedroom",
            text: "Price",
            formatter: (cell: any) => (cell ? `${cell}` : "$0"),
            headerStyle: { width: "7rem", color: "#0000ff" },
        },
        {
            dataField: "rentYield",
            text: "Yield",
            headerStyle: { width: "6rem", color: "#0000ff" },
            formatter: (cell: any) => `${cell} ${cell ? "" : ''}`
        },
        {
            dataField: "houseSize",
            text: "House",
            headerStyle: { width: "5rem", color: "#0000ff" },
            formatter: (cell: any) => `${cell} ${cell ? "" : ''}`
        },
        {
            dataField: "landSize",
            text: "Land",
            headerStyle: { width: "5rem", color: "#0000ff" },
            formatter: (cell: any) => `${cell} ${cell ? "" : ''}`
        },
        { dataField: "bedrooms", text: "Beds", headerStyle: { width: "5rem", color: "#0000ff" } },

        { dataField: "titled", text: "Titled", headerStyle: { width: "7rem", color: "#0000ff" } },
        //         {
        //             dataField: "actions",
        //             text: (
        //                 <>
        //                     <span>Action</span>
        //                     {/* {RoleName !== 'Viewer' && (
        //   <button onClick={handleClick}>
        //     Submit
        //   </button>
        // )} */}
        //                     {(RoleID === '1' || RoleID === '4' || RoleID === '5') && (
        //                         <Button color="danger" style={{ marginLeft: "10px" }} onClick={() => confirmDeleteProperty()}>
        //                             Delete
        //                         </Button>
        //                     )}
        //                 </>
        //             ),
        //             formatter: (_: any, row: any) => {
        //                 // Check if all five images are uploaded
        //                 const allImagesUploaded =
        //                     row.subdivisionImage ||
        //                     row.builderFaçadePageimage ||
        //                     row.floorPlanimage ||
        //                     row.inclusionsimage ||
        //                     row.ndiSimage ||
        //                     row.estateimage;

        //                 return (
        //                     <ul className="action simple-list d-flex flex-row align-items-center">
        //                         {(RoleID === '1' || RoleID === '4' || RoleID === '5') && (
        //                             <li style={{ cursor: "pointer" }} className="delete">
        //                                 <Link style={{ marginRight: "10px" }} className="primary" to={`/EditProperty/${row.propertyId}`}>
        //                                     Edit |
        //                                 </Link>
        //                             </li>

        //                         )}
        //                         {/* <span style={{ color: 'blue' }}> |</span> */}

        //                         <li
        //                             style={{ cursor: "pointer", marginLeft: '10px' }}
        //                             onClick={() => { setSelectedFlyer(row) }}
        //                             className="edit"
        //                         >
        //                             <a className="primary">Flyer</a>
        //                         </li>
        //                         <span style={{ color: 'blue' }}> |</span>

        //                         {allImagesUploaded && (
        //                             <>
        //                                 <li
        //                                     style={{ cursor: "pointer", marginLeft: '10px', marginRight: '10px' }}
        //                                     className="delete"
        //                                 >
        //                                     <span className="primary" style={{ color: 'var(--theme-default)' }} onClick={() => setSelectedPackage(row)}>
        //                                         Package
        //                                     </span>
        //                                 </li>
        //                                 <span style={{ color: 'blue' }}> |</span>
        //                             </>
        //                         )}

        //                         <>

        //                             {/* <li
        //                                     style={{ cursor: "pointer", marginLeft: '10px', marginRight: '10px' }}
        //                                     className="delete"  
        //                                 >
        //                                          Upload
        //                                  </li>
        //                                 <span style={{ color: 'blue' }}> |</span> */}

        //                             {



        //                                 !row.brochurepdf ? (



        //                                     <>
        //                                     {(RoleID === '1' || RoleID === '4' || RoleID === '5')&& (
        //                                         <li
        //                                             style={{ cursor: "pointer", color: 'blue', marginLeft: "10px", marginRight: "10px" }}
        //                                             onClick={() => {
        //                                                 setSelectedPropertyId(row.propertyId); // 👈 property id set karo
        //                                                 setIsModalOpen(true);                  // 👈 modal khol do
        //                                             }}
        //                                         >
        //                                             BROCHURE |
        //                                         </li> )}

        //                                         {/* <span style={{ color: "blue" }}> |</span> */}
        //                                     </>
        //                                 ) : (
        //                                     <>

        //                                         <li
        //                                             style={{ cursor: "pointer", marginLeft: '10px', marginRight: '10px', color: 'blue' }}
        //                                             className="download"
        //                                             onClick={() => {
        //                                                 const baseUrl = process.env.REACT_APP_API_BASE_URL;
        //                                                 const brochureUrl = `${baseUrl}/brochures/${row.brochurepdf}`;  // Construct full URL
        //                                                 const newTab = window.open(brochureUrl, '_blank');

        //                                                 if (!newTab) {
        //                                                     alert('Popup blocked! Please allow popups for this site.');
        //                                                 }
        //                                             }}
        //                                         >
        //                                             View PDF |
        //                                         </li>

        //                                         {/* <span style={{ color: 'blue' }}> |</span> */}
        //                                     </>
        //                                 )
        //                             }

        //                         </>





        //                         {/* Show "Yes" if all images are uploaded, otherwise "No" */}
        //                         {/* {allImagesUploaded ? (
        //                             <li style={{ marginLeft: "10px", display: "flex", alignItems: "center" }}>
        //                                 <label htmlFor={`yes-${row.propertyId}`} style={{ color: "green", fontWeight: "bold" }}>Yes</label>
        //                             </li>
        //                         ) : (
        //                             <li style={{ marginLeft: "10px", display: "flex", alignItems: "center" }}>
        //                                 <label htmlFor={`no-${row.propertyId}`} style={{ color: "red", fontWeight: "bold" }}>No</label>
        //                             </li>
        //                         )} */}
        //                     </ul>
        //                 );
        //             },
        //             headerStyle: { color: "#0000ff" },
        //         }


        {
            dataField: "actions",
            text: (
                <>
                    <span>Action</span>
                    {(RoleID === '1' || RoleID === '4' || RoleID === '5') && (
                        <Button color="danger" style={{ marginLeft: "10px" }} onClick={() => confirmDeleteProperty()}>
                            Delete
                        </Button>
                    )}
                </>
            ),
            formatter: (_: any, row: any) => {
                // 👇 If propertyKenket = 1, hide all actions
                if (row.propertyKenket === 1) {
                    if (row.brochurepdf) {
                        const baseUrl = process.env.REACT_APP_API_BASE_URL;
                        const brochureUrl = `${row.brochurepdf}`;

                        return (
                            <ul className="action simple-list d-flex flex-row align-items-center">
                                {/* View PDF - Modified to open modal */}
                                <li
                                    style={{
                                        cursor: "pointer",
                                        marginLeft: "10px",
                                        marginRight: "10px",
                                        color: "blue",
                                    }}
                                    onClick={() => {
                                        setSelectedPropertyDetails(row);
                                        setPropertyDetailsModal(true);
                                    }}
                                >
                                    👁️ View
                                </li>

                                {/* Download PDF */}
                                <li
                                    style={{
                                        cursor: "pointer",
                                        marginLeft: "10px",
                                        marginRight: "10px",
                                        color: "green",
                                    }}
                                >
                                    <a
                                        href={brochureUrl}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        download
                                        style={{ color: "green", textDecoration: "none" }}
                                    >
                                        ⬇️ Brochure
                                    </a>
                                </li>
                            </ul>
                        );
                    }

                    // 🚫 If no brochure available, show message
                    return (
                        <span style={{ color: "red", fontWeight: "bold" }}>
                            No Brochure Available
                        </span>
                    );
                }

                // ✅ Normal action buttons if propertyKenket = 0
                const allImagesUploaded =
                    row.subdivisionImage ||
                    row.builderFaçadePageimage ||
                    row.floorPlanimage ||
                    row.inclusionsimage ||
                    row.ndiSimage ||
                    row.estateimage;

                return (
                    <ul className="action simple-list d-flex flex-row align-items-center">
                        {(RoleID === '1' || RoleID === '4' || RoleID === '5') && (
                            <li style={{ cursor: "pointer" }} className="delete">
                                <Link
                                    style={{ marginRight: "10px" }}
                                    className="primary"
                                    to={`/EditProperty/${row.propertyId}`}
                                >
                                    Edit |
                                </Link>
                            </li>
                        )}

                        <li
                            style={{ cursor: "pointer", marginLeft: "10px" }}
                            onClick={() => setSelectedFlyer(row)}
                            className="edit"
                        >
                            <a className="primary">Flyer</a>
                        </li>
                        <span style={{ color: "blue" }}> |</span>

                        {allImagesUploaded && (
                            <>
                                <li
                                    style={{
                                        cursor: "pointer",
                                        marginLeft: "10px",
                                        marginRight: "10px",
                                    }}
                                    className="delete"
                                >
                                    <span
                                        className="primary"
                                        style={{ color: "var(--theme-default)" }}
                                        onClick={() => setSelectedPackage(row)}
                                    >
                                        Package
                                    </span>
                                </li>
                                <span style={{ color: "blue" }}> |</span>
                            </>
                        )}

                        {!row.brochurepdf ? (
                            <>
                                {(RoleID === '1' || RoleID === '4' || RoleID === '5') && (
                                    <li
                                        style={{
                                            cursor: "pointer",
                                            color: "blue",
                                            marginLeft: "10px",
                                            marginRight: "10px",
                                        }}
                                        onClick={() => {
                                            setSelectedPropertyId(row.propertyId);
                                            setIsModalOpen(true);
                                        }}
                                    >
                                        BROCHURE |
                                    </li>
                                )}
                            </>
                        ) : (
                            <>
                                <li
                                    style={{
                                        cursor: "pointer",
                                        marginLeft: "10px",
                                        marginRight: "10px",
                                        color: "blue",
                                    }}
                                    className="download"
                                    onClick={() => {
                                        const baseUrl =
                                            process.env.REACT_APP_API_BASE_URL;
                                        const brochureUrl = `${baseUrl}/brochures/${row.brochurepdf}`;
                                        const newTab = window.open(brochureUrl, "_blank");
                                        if (!newTab) {
                                            alert(
                                                "Popup blocked! Please allow popups for this site."
                                            );
                                        }
                                    }}
                                >
                                    View PDF |
                                </li>
                            </>
                        )}
                    </ul>
                );
            },
            headerStyle: { color: "#0000ff" },
        }









        // {
        //     dataField: "",
        //     text: "",
        //     headerFormatter: () => (
        //         <div style={{ textAlign: "center" }}>
        //             <Button color="danger" onClick={() => confirmDeleteProperty()}>
        //                 Delete
        //             </Button>
        //         </div>
        //     ),
        //     formatter: () => null,
        //     headerStyle: { textAlign: "center" }
        // }

    ];
    return (
        <>
            {/* <div dangerouslySetInnerHTML={{ __html: CompanyProfile() }} /> */}


            <div className='container-fluid'>
                <div className="table-responsive h-100 py-4">
                    <section className='bg-white'>
                        <div className="scrollable-table-container">
                            <table className="scrollable-table" style={{ marginLeft: '1%', marginTop: '3%' }}>
                                <div className="d-flex align-items-center">
                                    <Col xs={12} className='d-flex'>
                                        <H3 className="heading-color f-w-900 text-left">Property Search</H3>
                                    </Col>
                                </div>


                                <Row className='mt-4'>
                                    <div className='d-flex item-center mt-2'>
                                        <Col className="responsive-col" xs={12} style={{ width: '7%', paddingInline: '2px' }}>
                                            <Label className="mb-3">Property ID:</Label>
                                        </Col>
                                        <Col className="responsive-col" xs={12} style={{ width: '14%', paddingInline: '2px' }}>
                                            <TextField
                                                label=""
                                                type="text"
                                                name="propertyId"
                                                value={formData.propertyId}
                                                setValue={handleValueChange}
                                                placeholder=""
                                                design="flex"
                                                passCol='col-10'
                                                maxChars={6}
                                                tabIndex={1}
                                            />
                                        </Col>
                                        <Col className="responsive-col" xs={12} style={{ width: '5%', paddingInline: '2px' }}>
                                            <Label className="mb-3">State:</Label>
                                        </Col>
                                        <Col className="responsive-col" xs={12} style={{ width: '14%', paddingInline: '2px' }}>
                                            <DropdownWithValueName
                                                label=""
                                                name="state"
                                                value={formData.state}
                                                setValue={handleValueChange}
                                                options={statesData || []}
                                                required={true}
                                                tabIndex={5}
                                                passCol="col-10"
                                            />
                                        </Col>
                                        <Col className="responsive-col" xs={12} style={{ width: '8%', paddingInline: '2px' }}>
                                            <Label className="mb-3">Highest Yield:</Label>
                                        </Col>
                                        <Col className="responsive-col" xs={12} style={{ width: '14%', paddingInline: '2px' }}>
                                            <Dropdown
                                                label=""
                                                name="yield"
                                                value={formData.yield}
                                                setValue={handleValueChange}
                                                options={property.yield}
                                                required={true}
                                                tabIndex={5}
                                                passCol="col-10"
                                            />
                                        </Col>
                                        <Col className="responsive-col" xs={12} style={{ width: '8%', paddingInline: '2px' }}>
                                            <Label className="mb-3">Minimum Bed:</Label>
                                        </Col>
                                        <Col className="responsive-col" xs={12} style={{ width: '14%', paddingInline: '2px' }}>
                                            <DropdownWithValueName
                                                label=""
                                                name="minimumBed"
                                                value={formData.minimumBed}
                                                setValue={handleValueChange}
                                                options={property.minimumBed}
                                                required={true}
                                                tabIndex={5}
                                                passCol="col-10"
                                            />
                                        </Col>
                                        <Button onClick={handleSearch} size="sm" style={{ marginBottom: '16px', fontSize: '15px', width: '10%' }} className="text-center" color="success" >
                                            Search Now
                                        </Button>
                                    </div>
                                    <div className="d-flex align-items-center">
                                        <Col className="responsive-col" xs={12} style={{ width: '7%', paddingInline: '2px' }}>
                                            <Label className="mb-3">Max Price:</Label>
                                        </Col>
                                        <Col className="responsive-col" xs={12} style={{ width: '14%', paddingInline: '2px' }}>
                                            <DropdownWithValueName
                                                label=""
                                                name="maxPrice"
                                                value={formData.maxPrice}
                                                setValue={handleValueChange}
                                                options={property.maxPrice}
                                                tabIndex={1}
                                                passCol="col-10"
                                            />
                                        </Col>
                                        <Col className="responsive-col" xs={12} style={{ width: '5%', paddingInline: '2px' }}>
                                            <Label className="mb-3">Area:</Label>
                                        </Col>
                                        <Col className="responsive-col" xs={12} style={{ width: '14%', paddingInline: '2px' }}>
                                            <DropdownWithValueName
                                                label=""
                                                name="area"
                                                value={formData.area}
                                                setValue={handleValueChange}
                                                options={areasData || []}
                                                tabIndex={2}
                                                passCol="col-10"
                                            />
                                        </Col>
                                        <Col className="responsive-col" xs={12} style={{ width: '8%', paddingInline: '2px' }}>
                                            <Label className="mb-3">Titled:</Label>
                                        </Col>
                                        <Col className="responsive-col" xs={12} style={{ width: '14%', paddingInline: '2px' }}>
                                            <Dropdown
                                                label=""
                                                name="titled"
                                                value={formData.titled}
                                                setValue={handleValueChange}
                                                options={property.titled}
                                                tabIndex={3}
                                                passCol="col-10"
                                            />
                                        </Col>
                                        <Col className="responsive-col" xs={12} style={{ width: '8%', paddingInline: '2px' }}>
                                            <Label className="mb-3">Contract Type:</Label>
                                        </Col>
                                        <Col className="responsive-col" xs={12} style={{ width: '14%', paddingInline: '2px' }}>
                                            <DropdownWithValueName
                                                label=""
                                                name="contractType"
                                                value={formData.contractType}
                                                setValue={handleValueChange}
                                                options={property.contractType}
                                                tabIndex={4}
                                                passCol="col-10"
                                            />
                                        </Col>

                                        {(RoleID === '1' || RoleID === '4' || RoleID === '5') && (


                                            <Button color="primary" size="sm" style={{ marginBottom: '14px', fontSize: '15px', width: '10%' }} onClick={() => navigate("/AddProperty")}>Add Property</Button>
                                        )}
                                    </div>

                                    {/* Third Row */}
                                    <div className="d-flex align-items-center">
                                        <Col className="responsive-col" xs={12} style={{ width: '7%', paddingInline: '2px' }}>
                                            <Label className="mb-3">Prop Type:</Label>
                                        </Col>
                                        <Col className="responsive-col" xs={12} style={{ width: '14%', paddingInline: '2px' }}>
                                            <Dropdown
                                                label=""
                                                name="propType"
                                                value={formData.propType}
                                                setValue={handleValueChange}
                                                options={property.propType}
                                                tabIndex={5}
                                                passCol="col-10"
                                            />
                                        </Col>
                                        <Col className="responsive-col" xs={12} style={{ width: '5%', paddingInline: '2px' }}>
                                            <Label className="mb-3">Suburb:</Label>
                                        </Col>
                                        <Col className="responsive-col" xs={12} style={{ width: '14%', paddingInline: '2px' }}>
                                            <DropdownWithValueName
                                                label=""
                                                name="suburb"
                                                value={formData.suburb}
                                                setValue={handleValueChange}
                                                options={[...suburb].sort((a, b) => a.label.localeCompare(b.label))}
                                                tabIndex={6}
                                                passCol="col-10"
                                            />
                                        </Col>
                                        <Col className="responsive-col" xs={12} style={{ width: '8%', paddingInline: '2px' }}>
                                            <Label className="mb-3">Land Size:</Label>
                                        </Col>
                                        <Col className="responsive-col" xs={12} style={{ width: '14%', paddingInline: '2px' }}>
                                            <DropdownWithValueName
                                                label=""
                                                name="landSize"
                                                value={formData.landSize}
                                                setValue={handleValueChange}
                                                options={property.landSize}
                                                tabIndex={7}
                                                passCol="col-10"
                                            />
                                        </Col>


                                        <Col className="responsive-col" xs={12} style={{ width: '8%', paddingInline: '2px' }}>
                                            <Label className="mb-3">Builder:</Label>

                                        </Col>
                                        <Col className="responsive-col" xs={12} style={{ width: '14%', paddingInline: '2px' }}>
                                            <DropdownWithValueName
                                                label=""
                                                name="supplier"
                                                options={builders}
                                                value={formData.supplier}
                                                setValue={handleValueChange}
                                                tabIndex={7}

                                                passCol="col-10"
                                            />
                                        </Col>
                                        <Button
                                            color="primary"
                                            size="sm"
                                            onClick={exportToPDF}
                                            disabled={propertiesData.length === 0}
                                            style={{ marginBottom: '14px', fontSize: '15px', width: '10%' }}
                                        >
                                            Property List
                                        </Button>
                                    </div>
                                    {/* <div className="d-flex align-items-center">

                                        <Col className="responsive-col" xs={12} style={{ width: '7%', paddingInline: '2px' }}>
                                            <Label className="mb-3">Source:</Label>

                                        </Col>
                                        <Col
                                            className="responsive-col"
                                            xs={12}
                                            style={{ width: '14%', paddingInline: '2px' }}
                                        >
                                            <DropdownWithValueName
                                                label=""
                                                name="propertyKenket"
                                                value={formData.propertyKenket}
                                                setValue={handleValueChange}
                                                options={[
                                                    // { label: "Both", value: "2" },        // default → both tables
                                                    { label: "Old Properties", value: "0" }, // tbl_Properties
                                                    { label: "New Properties", value: "1" }  // PropertyDetailsKenket
                                                ]}

                                                required={false}
                                                tabIndex={6}
                                                passCol="col-10"
                                            />
                                        </Col>
                                    </div> */}
                                </Row>
                            </table>
                        </div>
                    </section>
                </div>
                {propertiesData.length !== 0 ? (
                    <div
                        style={{
                            borderRadius: "8px",
                            boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                            padding: "5px",
                            backgroundColor: "#fff",
                            overflowX: "auto",
                            width: "100%",
                        }}
                        className="mb-4"
                    >
                        <div style={{ minWidth: "max-content" }}>
                            {/* <BootstrapTable
                                keyField="propertyId"
                                // data={propertiesData}
                                data={sortedPropertiesData}

                                columns={propertyColumns as any}
                                selectRow={selectRow as any}
                                bordered={false}
                                wrapperClasses="table-responsive"
                            /> */}

                            {/*  */}

                            <BootstrapTable
                                keyField="propertyId"
                                data={sortedPropertiesData}
                                columns={propertyColumns as any}
                                selectRow={selectRow as any}
                                bordered={false}
                                wrapperClasses="table-responsive"
                            />
                        <div
  className="d-flex justify-content-between align-items-center mt-3"
  style={{ width: "100%", maxWidth: "500px", margin: "0 auto" }}
>
  {/* Previous */}
  <Button
    color="secondary"
    disabled={currentPage === 1 || allPropertiesLoading}
    onClick={() => setCurrentPage((prev) => prev - 1)}
  >
    Previous
  </Button>

  {/* Page numbers */}
  <div className="d-flex gap-2">
    {[1, 2, 3, 4].map((page) => (
      <Button
        key={page}
        color={currentPage === page ? "primary" : "light"}
        disabled={allPropertiesLoading}
        onClick={() => setCurrentPage(page)}
      >
        {page}
      </Button>
    ))}
  </div>

  {/* Next */}
  <Button
    color="primary"
    disabled={!hasMore || allPropertiesLoading}
    onClick={() => setCurrentPage((prev) => prev + 1)}
  >
    Next
  </Button>
</div>



                            {allPropertiesLoading && (
                                <div style={{ textAlign: "center", padding: "10px" }}>
                                    <Spinner color="primary" />
                                </div>
                            )}

                            {!hasMore && !allPropertiesLoading && (
                                <div style={{ textAlign: "center", padding: "10px" }}>
                                    {/* <b>No more data</b> */}
                                </div>
                            )}

                        </div>
                    </div>
                ) : allPropertiesLoading ? (
                    <div
                        style={{
                            borderRadius: "8px",
                            boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                            padding: "12px",
                            backgroundColor: "#fff",
                            textAlign: "center",
                        }}
                        className="mt-4 mb-2"
                    >
                        <Spinner color="primary" />
                    </div>
                ) : (
                    <div
                        style={{
                            borderRadius: "8px",
                            boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                            padding: "12px",
                            backgroundColor: "#fff",
                            textAlign: "center",
                        }}
                        className="mt-4 mb-2"
                    >
                        <h6>No properties data available.</h6>
                    </div>
                )}
            </div>
            <Modal isOpen={deleteModal} toggle={() => setDeleteModal(!deleteModal)} centered>
                <ModalHeader toggle={() => setDeleteModal(!deleteModal)}>Confirm Delete</ModalHeader>
                <ModalBody>Are you sure you want to delete these properties ?</ModalBody>
                <ModalFooter>
                    <Button color="primary" onClick={() => setDeleteModal(false)}>Cancel</Button>
                    <Button color="danger" onClick={handleDeletePropertyClick} disabled={isSoftDeletePending}>
                        {isSoftDeletePending ? "Deleting..." : "Delete"}
                    </Button>
                </ModalFooter>
            </Modal>

            <Modal isOpen={isModalOpen} toggle={() => setIsModalOpen(false)} centered>
                <ModalHeader toggle={() => setIsModalOpen(false)}>Upload Brochure</ModalHeader>
                <ModalBody>
                    <input
                        type="file"
                        accept="application/pdf"
                        onChange={(e) => {
                            if (e.target.files && e.target.files[0]) {
                                const file = e.target.files[0];
                                if (file.type === "application/pdf") {
                                    setSelectedFile(file);
                                } else {
                                    alert("Please upload only PDF file");
                                }
                            }
                        }}
                    />

                </ModalBody>
                <ModalFooter>
                    <Button color="primary" onClick={handleUpload}>Upload</Button>
                    <Button color="secondary" onClick={() => setIsModalOpen(false)}>Cancel</Button>
                </ModalFooter>
            </Modal>

            <Modal isOpen={propertyDetailsModal} toggle={() => setPropertyDetailsModal(!propertyDetailsModal)} size="lg">
                <ModalHeader toggle={() => setPropertyDetailsModal(!propertyDetailsModal)}>
                    Property Details
                </ModalHeader>
                <ModalBody>
                    {selectedPropertyDetails && (
                        <div className="property-details">
                            <Row>
                                <Col md="6">
                                    <h5>Basic Information</h5>
                                    <p><strong>Property ID:</strong> {selectedPropertyDetails.propertyId}</p>
                                    <p><strong>Address:</strong> {selectedPropertyDetails.propertyAddress}</p>
                                    <p><strong>Lot Number:</strong> {selectedPropertyDetails.lotNumber}</p>
                                    <p><strong>Suburb:</strong> {selectedPropertyDetails.suburb}</p>
                                    <p><strong>State:</strong> {selectedPropertyDetails.stateName}</p>
                                    <p><strong>Estate:</strong> {selectedPropertyDetails.estate}</p>
                                </Col>
                                <Col md="6">
                                    <h5>Property Specifications</h5>
                                    <p><strong>Property Type:</strong> {selectedPropertyDetails.propertyType}</p>
                                    <p><strong>Price:</strong> ${selectedPropertyDetails.price1Bedroom}</p>
                                    <p><strong>Bedrooms:</strong> {selectedPropertyDetails.bedrooms}</p>
                                    <p><strong>House Size:</strong> {selectedPropertyDetails.houseSize}</p>
                                    <p><strong>Land Size:</strong> {selectedPropertyDetails.landSize}</p>
                                    <p><strong>Yield:</strong> {selectedPropertyDetails.rentYield}</p>
                                    <p><strong>Titled:</strong> {selectedPropertyDetails.titled}</p>
                                </Col>
                            </Row>
                        </div>
                    )}
                </ModalBody>
                <ModalFooter>
                    {selectedPropertyDetails && selectedPropertyDetails.brochurepdf && (
                        <Button 
                            color="primary" 
                            onClick={() => window.open(selectedPropertyDetails.brochurepdf, "_blank")}
                        >
                            Open Brochure
                        </Button>
                    )}
                    <Button color="secondary" onClick={() => setPropertyDetailsModal(!propertyDetailsModal)}>
                        Close
                    </Button>
                </ModalFooter>
            </Modal>

        </>
    );
}